import { render, staticRenderFns } from "./SignatureElementSettings.vue?vue&type=template&id=22a144be&scoped=true&"
import script from "./SignatureElementSettings.vue?vue&type=script&lang=ts&"
export * from "./SignatureElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a144be",
  null
  
)

export default component.exports